import { updateKeyInStore } from 'App';
import { SaleOfOtherAssetsStateValues, updateKey } from '../slice';

export const uploadFields:
  | IBaseField<keyof SaleOfOtherAssetsStateValues>
  | {}[] = [
  {
    name: 'pleaseUploadAClosingStatementOrOtherDocumentationOfTheSale',
    label:
      'Please upload a closing statement or other documentation of the sale.',
    type: 'upload',
    effect: updateKeyInStore(updateKey),
    predicate: (v: string) => v === 'yes',
    comment: true,
    dependentOn:
      'taxQuestionnaire.soleProprietorship.saleofOtherAssets.values.doYouHaveAClosingStatementOrOtherDocumentationOfTheSale',
  },
];
